import React from "react";
import SoKnoLogo from "@/components/SoKnoLogo";

function scrollToId(id) {
  return (e) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
}

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="hero-section section-tone section-tone-hero relative"
    >
      {/* Curtain backdrop */}
      <div className="curtain-stage" aria-hidden="true">
        <div className="curtain-pillar left flicker" />
        <div className="curtain-pillar right flicker" style={{ animationDelay: "1.5s" }} />
        <div className="stage-floor" />
        <div className="vignette" />
      </div>

      <div className="container-x relative hero-inner">
        <div
          className="flex flex-col items-center text-center"
          style={{ animation: "fadeUp 1000ms ease both" }}
        >
          <SoKnoLogo size={320} className="hero-logo" />

          <div className="ornament mt-5 md:mt-8" aria-hidden="true">
            <span />
            <svg width="10" height="10" viewBox="0 0 10 10">
              <path d="M5 0 L10 5 L5 10 L0 5 Z" fill="#d6af63" />
            </svg>
            <span />
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display mt-5 md:mt-8"
            style={{
              fontSize: "clamp(2.1rem, 5.4vw, 4.4rem)",
              fontWeight: 500,
              lineHeight: 1.06,
              letterSpacing: "-0.015em",
              color: "var(--sokno-cream)",
              maxWidth: "20ch",
            }}
          >
            Opening Doors to{" "}
            <span className="text-gold-gradient" style={{ fontStyle: "italic" }}>
              Bold Independent Storytelling
            </span>
          </h1>

          <p
            data-testid="hero-copy"
            className="mt-5 md:mt-8 section-copy"
            style={{
              fontSize: 17,
              maxWidth: "62ch",
              textAlign: "center",
              color: "rgba(243,233,210,0.82)",
            }}
          >
            SoKno Productions develops original films, partners with creative and production
            talent, and builds opportunities that move powerful stories from vision to screen.
          </p>

          <div
            className="mt-8 md:mt-12 flex flex-wrap items-center justify-center gap-4"
            data-testid="hero-cta-row"
          >
            <a
              href="#projects"
              onClick={scrollToId("#projects")}
              data-testid="hero-btn-view-projects"
              className="btn-gold"
            >
              View Projects
            </a>
            <a
              href="#about"
              onClick={scrollToId("#about")}
              data-testid="hero-btn-about-studio"
              className="btn-ghost"
            >
              About the Studio
            </a>
          </div>

          {/* Scroll indicator */}
          <div
            className="hero-scroll-indicator mt-10 md:mt-20 flex flex-col items-center"
            style={{ color: "var(--sokno-cream-dim)" }}
            aria-hidden="true"
          >
            <span className="font-script" style={{ fontSize: 10, letterSpacing: "0.3em" }}>
              Scroll
            </span>
            <span
              style={{
                width: 1,
                height: 56,
                marginTop: 10,
                background: "linear-gradient(180deg, var(--sokno-gold), transparent)",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
